import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface Loca9Button {
  title: string;
  icon: string;
  description: string;
  color: string;
  view?: string;
}

interface CampanhaForm {
  nome: string;
  temImagem: boolean;
  imagemBase64: string | null;
  imagemPreview: string | null;
  inicio: string;
  fim: string;
}

interface CobrancaPushForm {
  nome: string;
  titulo: string;
  conteudo: string;
}

@Component({
  selector: 'app-loca9-app',
  templateUrl: './loca9-app.component.html',
  styleUrls: ['./loca9-app.component.css']
})
export class Loca9AppComponent {

  currentView: 'menu' | 'campanhas' | 'cobrancas-push' | 'nova-campanha' | 'nova-cobranca-push' = 'menu';

  buttons: Loca9Button[] = [
    {
      title: 'Campanhas',
      icon: 'fas fa-bullhorn',
      description: 'Gerencie campanhas de marketing e comunicação',
      color: '#3A4D56',
      view: 'campanhas'
    },
    {
      title: 'Dashboard',
      icon: 'fas fa-chart-line',
      description: 'Acompanhe métricas e indicadores do aplicativo',
      color: '#3A4D56'
    },
    {
      title: 'Cobranças Push',
      icon: 'fas fa-bell',
      description: 'Envie notificações de cobrança via push',
      color: '#3A4D56',
      view: 'cobrancas-push'
    }
  ];

  // Campanhas
  campanhas: any[] = [];
  campanhasColumns = [
    { titulo: 'Nome', label: 'nome' },
    { titulo: 'Imagem', label: 'imagem' },
    { titulo: 'Início', label: 'inicio' },
    { titulo: 'Fim', label: 'fim' }
  ];

  // Cobranças Push
  cobrancasPush: any[] = [];
  cobrancasPushColumns = [
    { titulo: 'Nome', label: 'nome' },
    { titulo: 'Texto', label: 'texto' },
    { titulo: 'Data Envio', label: 'dataEnvio' }
  ];

  // Nova Campanha Form
  campanhaForm: CampanhaForm = {
    nome: '',
    temImagem: false,
    imagemBase64: null,
    imagemPreview: null,
    inicio: '',
    fim: ''
  };

  // Nova Cobrança Push Form
  cobrancaPushForm: CobrancaPushForm = {
    nome: '',
    titulo: '',
    conteudo: ''
  };

  constructor(private router: Router) {}

  onButtonClick(button: Loca9Button): void {
    if (button.view) {
      this.currentView = button.view as any;
    }
  }

  goBack(): void {
    this.currentView = 'menu';
  }

  newCampanha(): void {
    this.resetCampanhaForm();
    this.currentView = 'nova-campanha';
  }

  newCobrancaPush(): void {
    this.resetCobrancaPushForm();
    this.currentView = 'nova-cobranca-push';
  }

  goBackToCampanhas(): void {
    this.currentView = 'campanhas';
  }

  goBackToCobrancasPush(): void {
    this.currentView = 'cobrancas-push';
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.campanhaForm.imagemBase64 = reader.result as string;
        this.campanhaForm.imagemPreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.campanhaForm.imagemBase64 = null;
    this.campanhaForm.imagemPreview = null;
  }

  get isCampanhaFormValid(): boolean {
    return !!(this.campanhaForm.nome && this.campanhaForm.inicio && this.campanhaForm.fim);
  }

  saveCampanha(): void {
    if (!this.isCampanhaFormValid) return;
    // TODO: chamar service para salvar campanha
    this.goBackToCampanhas();
  }

  get isCobrancaPushFormValid(): boolean {
    return !!(this.cobrancaPushForm.nome && this.cobrancaPushForm.titulo && this.cobrancaPushForm.conteudo);
  }

  saveCobrancaPush(): void {
    if (!this.isCobrancaPushFormValid) return;
    // TODO: chamar service para salvar cobrança push
    this.goBackToCobrancasPush();
  }

  private resetCampanhaForm(): void {
    this.campanhaForm = {
      nome: '',
      temImagem: false,
      imagemBase64: null,
      imagemPreview: null,
      inicio: '',
      fim: ''
    };
  }

  private resetCobrancaPushForm(): void {
    this.cobrancaPushForm = {
      nome: '',
      titulo: '',
      conteudo: ''
    };
  }
}
